import { memo, type ReactNode } from 'react';

export type MainSideNavItemIconProps = {
  children: ReactNode;
};

export const MainSideNavItemIcon = memo(({ children }: MainSideNavItemIconProps) => {
  return (
    <span className="flex w-[60px] shrink-0 items-center justify-center">
      <span className="relative flex size-9 shrink-0 items-center justify-center">{children}</span>
    </span>
  );
});

MainSideNavItemIcon.displayName = 'MainSideNavItemIcon';
